<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal" v-if="label">
            <label class="label">{{ label }}{{ required ? ' *' : '' }}</label>
        </div>
        <div class="field-body" :style="fieldBodyStyle">
            <input-only
                v-if="!$slots.custom"
                :loading="loading"
                :disabled="disabled"
                :id="id"
                :name="name"
                :type="type"
                :placeholder="placeholder"
                :isMoney="isMoney"
                :staticRight="staticRight"
                :inputClass="inputClass"
                v-model="myValue"
                :validator="validator"
                :info="info"
                :errorCond="errorCond"
                :errorMessage="errorMessage"
                :fieldStyle="fieldStyle"
                :controlStyle="controlStyle"
            />

            <div
                v-else
                :class="inputClass"
                style="border: none; box-shadow: none; display: flex; flex-basis: 100%;"
            >
                <slot name="custom"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import InputOnly from '../../_components/form/InputOnly';

export default {
    inheritAttrs: false,
    components: {
        InputOnly,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'text',
        },
        placeholder: {
            type: String,
            default: '',
        },
        isMoney: {
            type: Boolean,
            default: false,
        },
        staticRight: {
            type: String,
            default: '',
        },
        inputClass: {
            type: Array,
            default() { return []; },
        },
        value: {
            type: [Number, String, Boolean],
            default: '',
        },
        validator: {
            type: Object,
            default: null,
        },
        info: {
            type: String,
        },
        errorCond: {
            type: Boolean,
            default: true,
        },
        errorMessage: {
            type: String,
            default: '',
        },
        fieldBodyStyle: {
            type: String,
            default: '',
        },
        fieldStyle: {
            type: String,
            default: '',
        },
        controlStyle: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            myValue: this.value,
        }
    },
    watch: {
        value(cur) {
            this.myValue = cur;
        },
        myValue() {
            this.validator && this.validator.$touch();
            this.$emit('input', this.myValue);
        },
    },
}
</script>

<style lang="scss">
.field:not(:last-child) {
    margin-bottom: 10px;
}
</style>
